import { useEffect,useState } from 'react'
import LoaderAdm from '../../../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'
import TableDesconciliar from './TableDesconciliar'

const InputField = ({ label, placeholder, type, value, onChange, disabled = false, readOnly = false }) => (
  <div>
    <label className='block text-xs font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-xs text-xs
        ${disabled
          ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
          : 'focus:border-indigo-500 focus:ring-indigo-500'}
      `}
    />
  </div>
);

export default function ListDesconciliar({
  rows,
  filasSeleccionadas,
  onSeleccionar,
  setRowsSeleccionables,
  monthFilter,
  tipoMovimiento,
  setFilasSeleccionadas,
  setMontoTotalSeleccionado,
  montoTotalSeleccionado
}) {
  const [internalRows, setInternalRows] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [showFilters, setShowFilters] = useState(true)
  const [selectAll, setSelectAll] = useState(false);

useEffect(() => {
  if (!internalRows.length) return;

  const movimientos = internalRows
    .flatMap(r => r.auxiliar)
    .filter(aux => aux.tipoMovimiento === tipoMovimiento);

  const idsIniciales = movimientos.map(aux => aux.idPrincipal);

  const campoMonto = tipoMovimiento === 'cargo' ? 'montoCargo' : 'montoAbono';
  const totalInicial = movimientos.reduce(
    (sum, aux) => sum + (aux[campoMonto] || 0),
    0
  );

  onSeleccionar("SELECCIONAR_TODOS", movimientos, { idsIniciales, totalInicial });

  // Marcar checkbox
  setSelectAll(true);
}, [internalRows, tipoMovimiento]);

useEffect(() => {
  if (!internalRows.length) return;

  const movimientos = internalRows
    .flatMap(r => r.auxiliar)
    .filter(aux => aux.tipoMovimiento === tipoMovimiento);

  const totalIds = movimientos.map(aux => aux.idPrincipal);

  // Si las filas seleccionadas coinciden con todas → marcar checkbox
  setSelectAll(filasSeleccionadas.length === totalIds.length);
}, [filasSeleccionadas, internalRows, tipoMovimiento]);


  // Normalizar rows
  useEffect(() => {
    if (!rows) return;

    // maneja casos: array real o {0:[],1:[]}
    const arr = Array.isArray(rows) ? rows : Object.values(rows);

    const flattened = arr.flat();
    setInternalRows(flattened);
    setRowsSeleccionables(flattened);
  }, [rows]);

  const getMonth = fecha => {
    if (!fecha) return null;
    const d = new Date(fecha);
    if (isNaN(d)) return null;
    return String(d.getMonth() + 1).padStart(2, "0");
  };

  const filteredRows = internalRows.filter(r => {
    if (!monthFilter) return true;
    return getMonth(r.fecha) === monthFilter;
  });

  useEffect(() => {
  if (rows) {
    setIsLoadingData(false);
  }
}, [rows]);

  return (
    <div>
      <div className="">
        {showFilters && (
          <div className="flex flex-wrap gap-2 items-center border border-gray-200 rounded-3xl p-4 bg-gray-50 mb-2">
            <InputField label="Monto Total" type="text" value={montoTotalSeleccionado.toLocaleString('es-CL')} readOnly/>
            <div className="flex items-center gap-2 mt-4">
              <input
                type="checkbox"
                className="rounded"
                checked={selectAll}
                onChange={(e) => {
                  if (e.target.checked) {
                    const movimientos = internalRows
                      .flatMap(r => r.auxiliar)
                      .filter(aux => aux.tipoMovimiento === tipoMovimiento);

                    onSeleccionar("SELECCIONAR_TODOS", movimientos);
                  } else {
                    onSeleccionar("DESELECCIONAR_TODOS");
                  }
                }}
              />
              <label className="text-xs">
                {selectAll ? "Deseleccionar todo" : "Seleccionar todo"}
              </label>
            </div>
            <button
              className="ml-auto flex items-center px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
              onClick={() => setShowFilters(f => !f)}
            >
              <KeyboardArrowDownIcon className={clsx('transition-transform', { 'rotate-180': showFilters })} />
            </button>
          </div>
        )}
        {!showFilters && (
          <div className="flex justify-end mb-4">
            <button
              className="flex items-center px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
              onClick={() => setShowFilters(f => !f)}
            >
              <KeyboardArrowDownIcon className={clsx('transition-transform', { 'rotate-180': showFilters })} />
            </button>
          </div>
        )}
      {isLoadingData
        ? <div className="flex items-center justify-center h-full"><Lottie animationData={LoaderAdm} loop style={{ width:300, height:300 }} /></div>
        : <div className='overflow-x-auto pt-4'>
           <TableDesconciliar
            rows={filteredRows}
            filasSeleccionadas={filasSeleccionadas}
            onSeleccionar={onSeleccionar}
            tipoMovimiento={tipoMovimiento}
          />
          </div>
      }
      </div>
    </div>
  );
}
